import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Typography } from '@material-ui/core';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { BulletPoints } from 'components';

import useStyles from './styles';

const SimpleExpansionPanel = ({
  list,
  defaultExpanded,
  firstDefaultExpanded,
  titleTypographyVariant,
  panelDetailsClass
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const itemsRef = React.useRef([]);

  const scrollIntoView = idx => {
    const ref = itemsRef.current[idx];

    if (!ref || ref.isOpened) {
      ref.isOpened = false;
      return;
    }

    ref.isOpened = true;

    setTimeout(() => {
      ref.scrollIntoView({
        behavior: 'smooth'
      });
    }, 300);
  };

  React.useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, list.length);
  }, []);

  return (
    <div>
      {list.map((item, index) => (
        <Accordion
          key={item.title}
          classes={{ root: classes.panel }}
          defaultExpanded={
            firstDefaultExpanded && !index ? true : defaultExpanded
          }
          ref={el => (itemsRef.current[index] = el)}
        >
          <AccordionSummary
            classes={{
              root: classes.panelSummary,
              content: classes.panelSummaryContent,
              expandIcon: classes.expandIcon,
              expanded: classes.panelSummaryExpanded
            }}
            expandIcon={<ExpandMoreIcon classes={{ root: classes.icon }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            onClick={() => scrollIntoView(index)}
          >
            <Typography
              variant={
                titleTypographyVariant ? titleTypographyVariant : `body1`
              }
              classes={{ root: classes.title }}
            >
              {t(item.title)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            classes={{
              root: classNames(classes.panelDetails, panelDetailsClass)
            }}
          >
            {(item.title === 'What to bring' ||
              item.title === 'Included' ||
              item.title === 'Not included') && (
              <BulletPoints item={item.description.props.children} />
            )}

            {item.title === 'Overview' && item.image && (
              <div
                className={classes.image}
                style={{
                  backgroundImage: `url(${item.image})`
                }}
              >
                {''}
              </div>
            )}
            {item.title !== 'What to bring' &&
              item.title !== 'Included' &&
              item.title !== 'Not included' &&
              item.description}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default SimpleExpansionPanel;
